export default "__VITE_PUBLIC_ASSET__e66c93d9__"